import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { TrendingUp, Activity, Zap, ShieldCheck } from 'lucide-react';
const metrics = [{
  label: 'Average ROI Increase',
  value: '847%',
  icon: TrendingUp,
  color: 'text-emerald-400',
  bg: 'bg-emerald-400/10',
  description: 'Across all active campaigns in 2025'
}, {
  label: 'Ads Optimized',
  value: '2.3M+',
  icon: Zap,
  color: 'text-blue-400',
  bg: 'bg-blue-400/10',
  description: 'Processed by Nexus AI Engine'
}, {
  label: 'Campaigns Managed',
  value: '156K+',
  icon: Activity,
  color: 'text-purple-400',
  bg: 'bg-purple-400/10',
  description: 'Active global campaigns'
}, {
  label: 'Platform Uptime',
  value: '99.99%',
  icon: ShieldCheck,
  color: 'text-amber-400',
  bg: 'bg-amber-400/10',
  description: 'Enterprise-grade reliability'
}];
export function MetricsSection() {
  return <section className="py-24 bg-slate-950" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-179">
              <Card className="p-6 h-full bg-slate-900 border-slate-800 hover:border-slate-700 transition-colors" data-id="element-180">
                <div className={`w-12 h-12 rounded-lg ${metric.bg} flex items-center justify-center mb-4`} data-id="element-181">
                  <metric.icon className={`w-6 h-6 ${metric.color}`} data-id="element-182" />
                </div>
                <h3 className="text-4xl font-bold text-white mb-2 tracking-tight" data-id="element-183">
                  {metric.value}
                </h3>
                <p className="text-sm font-semibold text-slate-300 mb-2" data-id="element-184">
                  {metric.label}
                </p>
                <p className="text-xs text-slate-500" data-id="element-185">{metric.description}</p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}